import './LinkInputRow.css';
import { ErrorMessage, Field } from 'formik';

export const LinkInputRow = ({ handleChange, name }) => {
  return (
    <>
      <div className="link-input-row-container">
        <div className="link-input-wrapper">
          <span className="link-input-prefix">https://</span>
          <Field name={name} onChange={handleChange} className="link-input" />
        </div>
      </div>
      <ErrorMessage name={name} component={'p'} className={'form-control-error-message'} />
    </>
  );
};
